import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductoService {

  constructor() { }

  
  productos: any = [];

  nuevoProducto(id: any, producto: any, grabado: any, cantidad: any, precio: any, imagen: any, value: any, descripcion: any, largo: any, tipo: any, posicion: any){
    console.log("posicion: ", posicion);
    this.productos.unshift({
      id, nombre: producto, grabado, cantidad, precio, imagen, value,
      descripcion, largo, tipo, dedicatoria: "", posicion: posicion + this.productos.length
    });
  }
  nuevoProductoAudio(id: string, producto: any, grabado: any, cantidad: any, precio: any, imagen: any, value: any, descripcion: any, audio: any, largo: any, audio64: any, tipo: any, posicion: any){
    this.productos.unshift({
      id, nombre: producto, grabado, cantidad, precio, imagen , value, 
      descripcion, audio, largo, audio64, tipo, dedicatoria: "", posicion: posicion + this.productos.length
    })
  }

deleteBloque(index: number) {
  // Verificar que el índice es válido
  if (index < 0 || index >= this.productos.length) return;

  // Eliminar el peluche
  this.productos.splice(index, 1);

  // Eliminar accesorios asociados (hasta 10 o hasta que aparezca otro peluche)
  let count = 0;
  while (
    index < this.productos.length &&
    this.productos[index].tipo === 'accesorio' &&
    count < 10
  ) {
    this.productos.splice(index, 1);
    count++;
  }
}
   
}
